import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMCustomer, updateLLMPrompt } from "../graphql/mutations";
import {
  UpdateLLMCustomerInput,
  UpdateLLMCustomerMutation,
  UpdateLLMPromptInput,
  UpdateLLMPromptMutation,
} from "../API";

export async function updateLLMPromptAfterEdit(
  values: UpdateLLMPromptInput
): Promise<GraphQLResult<UpdateLLMPromptMutation>> {
  return API.graphql(
    graphqlOperation(updateLLMPrompt, {
      input: {
        id: values.id,
        name: values.name,
        status: values.status,
        projectId: values.projectId,
        key: values.key,
        description: values.description,
        prompt: values.prompt,
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMPromptMutation>>;
}
